export default Object.freeze( {
	OUTCOME_IMPORTANCE: "OUTCOME_IMPORTANCE",
	COMPLETED_RECENTLY: "COMPLETED_RECENTLY",
	CREATED_RECENTLY: "CREATED_RECENTLY",
} );



// WEBPACK FOOTER //
// ./src/constants/OutcomeSortType.js